export class CompanyAddress{

 loacs?: string;

 NAME: any;
 pais: number;
 estado: number;
 ciudad: number;
 OUTDOOR_NUMBER: any;
 STREET: any;
 INTERIOR_NUMBER: any;
 localidad: number;
 CP: number;
 colonia: number;
 REFERENCE: any;

 COMPANY_ADDRESS_ID: number

}


// WEBPACK FOOTER //
// ./src/app/models/direccionconpania.ts